import { render } from "./OneWaySearchForm.vue?vue&type=template&id=2dafa2d5"
import script from "./OneWaySearchForm.vue?vue&type=script&lang=js"
export * from "./OneWaySearchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__